import { Column } from "components/Column";
import type { ColumnAdapterProps } from "./Column.d";

const ColumnAdapter = ({
  blok: {
    colSpanMobile,
    colSpanTablet = "6",
    colSpanDesktop,
    vAlignmentMobile,
    vAlignmentTablet = "top",
    vAlignmentDesktop,
    mtMobile,
    mtTablet = "0",
    mtDesktop,
    mbMobile,
    mbTablet = "0",
    mbDesktop,
    hAlignmentMobile,
    hAlignmentTablet = "left",
    hAlignmentDesktop = "stretch",
    textAlignMobile,
    textAlignTablet = "left",
    textAlignDesktop,
    orderMobile,
    orderTablet = "0",
    orderDesktop,
    content,
  },
}: ColumnAdapterProps) => (
  <Column
    colSpanMobile={colSpanMobile}
    colSpanTablet={colSpanTablet}
    colSpanDesktop={colSpanDesktop}
    vAlignmentMobile={vAlignmentMobile}
    vAlignmentTablet={vAlignmentTablet}
    vAlignmentDesktop={vAlignmentDesktop}
    mtMobile={mtMobile}
    mtTablet={mtTablet}
    mtDesktop={mtDesktop}
    mbMobile={mbMobile}
    mbTablet={mbTablet}
    mbDesktop={mbDesktop}
    hAlignmentMobile={hAlignmentMobile}
    hAlignmentTablet={hAlignmentTablet}
    hAlignmentDesktop={hAlignmentDesktop}
    orderMobile={orderMobile}
    orderTablet={orderTablet}
    orderDesktop={orderDesktop}
    content={content}
    textAlignMobile={textAlignMobile}
    textAlignTablet={textAlignTablet}
    textAlignDesktop={textAlignDesktop}
  />
);

export default ColumnAdapter;
